import styled from 'styled-components';

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 250px;
  gap: 16px;
  padding: 16px;
  background-color: transparent;
  border: 1px solid #dcdcdc;

  cursor: pointer;

  @media ${(props) => props.theme.screen.sm} {
    gap: 24px;
  }

  @media ${(props) => props.theme.screen.md} {
    height: 370px;
    gap: 32px;
    padding: 24px;
  }
`;

export const LogoWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
  margin-top: 24px;
  transition: transform 0.3s ease;

  ${CardContainer}:hover & {
    transform: scale(1.1);
  }

  @media ${(props) => props.theme.screen.sm} {
    width: 120px;
    height: 120px;
  }

  @media ${(props) => props.theme.screen.md} {
    width: 170px;
    height: 170px;
    margin-top: 38px;
  }
`;

export const OrganizationLogo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const OrganizationName = styled.h3`
  font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  font-weight: ${(props) => props.theme.fontWeights.semiBold};
  font-size: 14px;
  line-height: 121%;
  letter-spacing: 0%;
  text-align: center;
  margin: 0;
  color: ${(props) => props.theme.colors.black};
  text-decoration: underline;
  text-decoration-color: transparent;
  text-underline-offset: 4px;
  transition: text-decoration-color 0.3s ease;

  ${CardContainer}:hover & {
    text-decoration-color: ${(props) => props.theme.colors.black};
  }

  @media ${(props) => props.theme.screen.md} {
    font-size: 16px;
  }
`;
